import { Modal } from '@zendeskgarden/react-modals'
import React from 'react'

import ChevronLeftIcon from '../../icons/ps_reporting_chevron_left.svg?react'
import CloseIcon from '../../icons/ps_reporting_close.svg?react'
import { Option } from '../../models/Option'
import { ReportSelectModalCard } from './ReportSelectModalCard'

type ReportSelectModalProps = {
    title: string | undefined
    selectValues: Option[]
    selectedValue: string | undefined
    onSelect: (option: Option) => void
    onClose: () => void
    onBack?: () => void
}

export const ReportSelectModal: React.FC<ReportSelectModalProps> = ({
    title,
    selectValues,
    selectedValue,
    onSelect,
    onClose,
    onBack,
}) => {
    // Group options by their group property
    const groupedOptions = selectValues.reduce(
        (groups: { [key: string]: Option[] }, option: Option) => {
            const groupKey = option.group || 'noGroup'
            if (!groups[groupKey]) {
                groups[groupKey] = []
            }
            groups[groupKey].push(option)
            return groups
        },
        {}
    )

    return (
        <Modal aria-label="Select modal" className="reportSelectModal" onClose={onClose}>
            <div className="header">
                {onBack && (
                    <div
                        className="back"
                        onClick={onBack}
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.stopPropagation()
                                onBack()
                            }
                        }}
                    >
                        <ChevronLeftIcon color="#314A68" />
                    </div>
                )}
                <div className={`title`}>{title}</div>
                <div
                    className="close"
                    tabIndex={0}
                    onClick={onClose}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.stopPropagation()
                            onClose()
                        }
                    }}
                >
                    <CloseIcon color="#314A68" />
                </div>
            </div>
            <div className="body">
                {Object.entries(groupedOptions).map(([group, options]) => (
                    <div className="group" key={group}>
                        {group !== 'noGroup' && <div className="title">{group}</div>}
                        <div className="body">
                            {options.map((option: Option) => {
                                const selected = option.id === selectedValue
                                return (
                                    <ReportSelectModalCard
                                        key={option.id}
                                        selected={selected}
                                        option={option}
                                        onSelect={onSelect}
                                    />
                                )
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    )
}
